import { X, TrendingUp, TrendingDown, Activity, Clock, CheckCircle, AlertCircle, XCircle, Shield } from "lucide-react";
import styles from "./Supplierhealthdetail.module.css";

const SupplierHealthDetail = ({ supplier, onClose }) => {
  if (!supplier) return null;

  const getStatusIcon = () => {
    switch(supplier.healthStatus) {
      case "Online": return <CheckCircle size={20} />;
      case "Degraded": return <AlertCircle size={20} />;
      case "Offline": return <XCircle size={20} />;
      default: return null;
    }
  };

  const getTrendIcon = () => {
    return supplier.uptimeTrend === "up" ? <TrendingUp size={18} /> : <TrendingDown size={18} />;
  };

  return (
    <>
      <div className={styles.backdrop} onClick={onClose}></div>

      <div className={styles.drawer}>
        <div className={styles.header}>
          <div className={styles.headerLeft}>
            <div className={styles.iconWrapper}>
              <Activity size={24} />
            </div>
            <div>
              <h2 className={styles.title}>Health Details: {supplier.name}</h2>
              <p className={styles.subtitle}>Detailed health and performance metrics</p>
            </div>
          </div>
          <button className={styles.closeBtn} onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div className={styles.content}>
          {/* Current Status Section */}
          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>Current Status</h3>
            <div className={styles.grid}>
              <div className={styles.statusCard}>
                <label className={styles.cardLabel}>Current Status</label>
                <div className={`${styles.statusBadge} ${styles[`status${supplier.healthStatus}`]}`}>
                  {getStatusIcon()}
                  <span>{supplier.healthStatus}</span>
                </div>
              </div>

              <div className={styles.statusCard}>
                <label className={styles.cardLabel}>Supplier Type</label>
                <div className={`${styles.typeBadge} ${styles[`type${supplier.type}`]}`}>
                  {supplier.type}
                </div>
              </div>
            </div>
          </div>

          {/* Performance Metrics Section */}
          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>Performance Metrics</h3>
            <div className={styles.grid}>
              <div className={styles.metricCard}>
                <div className={styles.metricHeader}>
                  <label className={styles.metricLabel}>Uptime</label>
                  <span className={`${styles.trendIcon} ${styles[`trend${supplier.uptimeTrend}`]}`}>
                    {getTrendIcon()}
                  </span>
                </div>
                <div className={styles.metricValue}>{supplier.uptime}%</div>
                <div className={styles.metricProgress}>
                  <div 
                    className={styles.metricProgressBar}
                    style={{ width: `${supplier.uptime}%` }}
                  ></div>
                </div>
              </div>

              <div className={styles.metricCard}>
                <div className={styles.metricHeader}>
                  <label className={styles.metricLabel}>Response Time</label>
                  <Clock size={16} className={styles.metricIcon} />
                </div>
                <div className={styles.metricValue}>{supplier.responseTime}</div>
                <div className={styles.metricHint}>
                  {supplier.responseTime === "-" ? "No data available" : "Average response time"}
                </div>
              </div>
            </div>
          </div>

          {/* Latest API Activity Section */}
          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>Latest API Activity</h3>
            <div className={styles.activityList}>
              <div className={styles.activityItem}>
                <div className={styles.activityLabel}>Last API Call</div>
                <div className={styles.activityValue}>
                  <Clock size={16} className={styles.activityIcon} />
                  {supplier.lastApiCall}
                </div>
              </div>

              <div className={styles.activityItem}>
                <div className={styles.activityLabel}>Last Result</div>
                <div className={styles.activityValue}>
                  <span className={`${styles.resultBadge} ${styles[`result${supplier.lastResult}`]}`}>
                    {supplier.lastResult}
                  </span>
                </div>
              </div>

              {supplier.lastError !== "-" && (
                <div className={styles.activityItem}>
                  <div className={styles.activityLabel}>Last Error</div>
                  <div className={styles.errorBox}>
                    <AlertCircle size={16} />
                    <span>{supplier.lastError}</span>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Supplier Info Section */}
          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>Supplier Information</h3>
            <div className={styles.infoGrid}>
              <div className={styles.infoItem}>
                <label className={styles.infoLabel}>Supplier ID</label>
                <div className={styles.infoValue}>{supplier.id}</div>
              </div>

              <div className={styles.infoItem}>
                <label className={styles.infoLabel}>Supplier Name</label>
                <div className={styles.infoValue}>{supplier.name}</div>
              </div>

              <div className={styles.infoItem}>
                <label className={styles.infoLabel}>Integration Type</label>
                <div className={styles.infoValue}>{supplier.type}</div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className={styles.footer}>
            <Clock size={14} />
            <span>Last updated: 2 minutes ago</span>
          </div>
        </div>
          <div className={styles.footerNew}>
          <button className={styles.closeFooterBtn} onClick={onClose}>
            <X size={16} />
            Close
          </button>
          <button className={styles.saveBtn}>
            <Shield size={16} />
            Save Changes
          </button>
        </div>
      </div>
    </>
  );
};

export default SupplierHealthDetail;